<!-- <footer class="m-grid__item m-footer ">
  <div class=" m-container--responsive m-container--xxl m-container--full-height m-page__container">
    <div class="m-footer__wrapper">
      <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
        <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
          <span class="m-footer__copyright">
            SIP
            <a href="https://keenthemes.com" class="m-link">

            </a>
          </span>
        </div>
        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
            <li class="m-nav__item">
              <a href="#" class="m-nav__link">
                <span class="m-nav__link-text">

                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="#" class="m-nav__link">
                <span class="m-nav__link-text">

                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="#" class="m-nav__link">
                <span class="m-nav__link-text">

                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="#" class="m-nav__link">
                <span class="m-nav__link-text">

                </span>
              </a>
            </li>
            <li class="m-nav__item m-nav__item--last">
              <a href="#" class="m-nav__link" data-toggle="m-tooltip" title="" data-placement="left" data-original-title="Support Center">
                <i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer> -->
<footer class="section" style="z-index: 9999;">
  <div class="continer custom-container">
    <div class="row footer-content">
      <div class="col-lg-6 col-md-6 text-center">
        <!-- Copyright&copy; 2018
        <a href="https://www.nsdcindia.org/" target="_blank"  rel="noopener" class="m--font-info">NSDC</a>.All Right Reserved -->
      </div>
      <div class="col-lg-6 col-md-6 text-center">
        <!-- Design &amp; Development by:
        <a href="http://www.transneuron.com/" target="_blank"  rel="noopener" class="m--font-info">
          Trans Neuron Technologies Pvt Ltd -->
        <!-- </a> -->
      </div>
    </div>
  </div>
</footer>
